
/* injects from baggage-loader */

const modulePhotoLibrary = angular.module('photolibrary.controller', []);

modulePhotoLibrary.controller("PhotoLibraryCtrl", [
  "$scope", "$rootScope", "$timeout", "Widget", "$modalInstance", "widget", "$filter",
  ($scope, $rootScope, $timeout, Widget, $modalInstance, widget, $filter) => {

    $scope.photolibrary = { currentSettings: 'categories' };
    $scope.widget = widget;

    const getTagsAndImages = () => {
      Widget.getImagesTags().then((tags) => {
        $scope.tags = tags;
        $scope.getImagesByTag($scope.tags[0], void 0);
        $scope.selectedCategory = $scope.tags[0];
      });
    };

    $scope.getImagesByTag = (tag) => {
      $scope.imagesLoading = true;
      Widget.getImagesByTag(tag, void 0).then((imagesData) => {
        $scope.imagesData = imagesData;
        $scope.imagesLoading = false;
      });
    };

    $scope.chooseImage = (image) => {
      $modalInstance.close(document.location.origin + image.image_attributes.source_url);
    };

    $scope.getWidgetTagName = (widget) => {
      let widgetTag = null;
      if (widget.tag) {
        widgetTag = widget.tag;

        if (widget.type && widget.type === 'list') {
          widgetTag = $filter('translate')('widget.tags.bullets')
        }
      }

      return widgetTag;
    };

    $scope.scrollDisabled = false;
    $scope.getNextImages = () => {
      if ($scope.imagesData.pagination.itemCount <= $scope.imagesData.images.length) {
        return false;
      }
      const lastId = $scope.imagesData.images[$scope.imagesData.images.length - 1].id;
      $scope.scrollDisabled = true;

      Widget.getImagesByTag($scope.selectedCategory, lastId).then((imagesData) => {
        $scope.imagesData.images = $scope.imagesData.images.concat(imagesData.images);
        $scope.scrollDisabled = imagesData.images.length === 0;
      });
    };

    if (widget.tag) {
      $scope.photolibrary.currentSettings = 'forsite';

      const widgetTag = $scope.getWidgetTagName(widget);
      $scope.getImagesByTag(widgetTag, true);
      Widget.getImagesTags().then((tags) => {
        $scope.tags = tags;
        $scope.selectedCategory = $scope.tags[0];
      });
    } else {
      getTagsAndImages();
    }
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/photo-library/photo-library.controller.js